module.exports = __webpack_public_path__ + "static/media/peche.0b0edab5.svg";